"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Environment = void 0;
var Environment = exports.Environment = /*#__PURE__*/function (Environment) {
  Environment["Preview"] = "preview";
  Environment["Production"] = "production";
  Environment["Qa"] = "qa";
  return Environment;
}({});